export enum ExamModeEnum {
  add,
  edit,
}
